module.exports = __webpack_public_path__ + "img/hxjzg.381b35e4.png";